import "./AutomatedOffersHeader.scss";
import { useState, useEffect, useCallback } from "react";
import brand from "./brands";
import PoweredByConstellation from "../../components/ui/PoweredByConstellation";

const { navLinks, header } = brand;

const SCROLL_THRESHOLD_PX = 32;
/** A section becomes active once its top passes this far below the viewport top. */
const ACTIVE_OFFSET_PX = 120;

function getActiveSection() {
	// At the very bottom, the last section may be too short to reach the offset.
	const atBottom =
		window.innerHeight + window.scrollY >=
		document.documentElement.scrollHeight - 2;
	let active = "";
	navLinks.forEach((link, i) => {
		const el = document.getElementById(link.href.slice(1));
		if (!el) return;
		const reached = el.getBoundingClientRect().top <= ACTIVE_OFFSET_PX;
		if (reached || (atBottom && i === navLinks.length - 1)) {
			active = link.href;
		}
	});
	return active;
}

/** Section nav | brand logo(s) | Constellation lockup. */
function AutomatedOffersHeader() {
	const [isScrolled, setIsScrolled] = useState(false);
	const [activeHref, setActiveHref] = useState("");

	const onScroll = useCallback(() => {
		setIsScrolled(window.scrollY > SCROLL_THRESHOLD_PX);
		setActiveHref(getActiveSection());
	}, []);

	useEffect(() => {
		onScroll();
		window.addEventListener("scroll", onScroll, { passive: true });
		return () => window.removeEventListener("scroll", onScroll);
	}, [onScroll]);

	const nav = (
		<nav className="ao-nav__links" aria-label="Page sections">
			{navLinks.map((link) => (
				<a
					key={link.href}
					href={link.href}
					className={activeHref === link.href ? "is-active" : undefined}
					aria-current={activeHref === link.href ? "location" : undefined}>
					{link.label}
				</a>
			))}
		</nav>
	);

	const logos = (
		<a className="ao-nav__brand" href="#top" aria-label={header.label}>
			{header.logos.map((logo, i) => (
				<span className="ao-nav__logo-group" key={logo.alt}>
					{i > 0 && <span className="ao-nav__logo-divider" aria-hidden="true" />}
					<img
						src={logo.src}
						alt=""
						className="ao-nav__logo"
						width={logo.width}
						height={logo.height}
						decoding="async"
					/>
				</span>
			))}
		</a>
	);

	return (
		<header className={`ao-nav${isScrolled ? " ao-nav--scrolled" : ""}`}>
			<div className="ao-nav__inner">
				{nav}
				{logos}
				<PoweredByConstellation stacked className="ao-nav__powered" />
			</div>
		</header>
	);
}

export default AutomatedOffersHeader;
